import React from 'react';

const TimelineItem = ({ item, type = 'experience' }) => {
    // İş türüne göre badge rengi
    const getTypeBadge = (type) => {
        const typeConfig = {
            'full-time': { color: '#10b981', label: 'Tam Zamanlı' },
            'internship': { color: '#3b82f6', label: 'Stajyer' },
            'startup': { color: '#8b5cf6', label: 'Startup' },
            'volunteer': { color: '#f59e0b', label: 'Gönüllü' },
            'part-time': { color: '#ec4899', label: 'Yarı Zamanlı' }
        };

        return typeConfig[type] || { color: '#6b7280', label: type };
    };

    return (
        <div className="timeline-item">
            <div className="timeline-dot" style={{ backgroundColor: item.color }}>
                {item.logo ? (
                    <img src={item.logo} alt={item.company || item.institution} className="logo-image" />
                ) : (
                    <div className="fallback-icon">
                        {type === 'education' ? '🎓' : '💼'}
                    </div>
                )}
            </div>

            <div className="timeline-content">
                <div className="timeline-year">
                    <span className="year-text">{item.year}</span>
                    {type === 'experience' && item.type && (
                        <span
                            className="type-badge"
                            style={{ backgroundColor: getTypeBadge(item.type).color }}
                        >
                            {getTypeBadge(item.type).label}
                        </span>
                    )}
                </div>

                <div className="timeline-card">
                    <div className="card-header">
                        {type === 'education' ? (
                            <>
                                <h3>{item.degree}</h3>
                                    <h4>{item.institution}</h4>
                            </>
                        ) : (
                            <>
                                <h3>{item.position}</h3>
                                <div className="company-info">
                                    <h4>{item.company}</h4>
                                    {item.location && (
                                        <span className="location-badge">
                                            <i className="fas fa-map-marker-alt"></i> {item.location}
                                        </span>
                                    )}
                                </div>
                            </>
                        )}
                    </div>

                    <p className="description">{item.description}</p>

                    {item.certificate && (
                        <div className="certificate-badge">
                            <i className="fas fa-certificate"></i>
                            <span>Sertifikalı Program</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TimelineItem;